module.exports = __webpack_public_path__ + "static/media/tnc.614c86ad.svg";